import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
// import Button from '@vzrf/react-button';
import { Button } from '@vds/buttons';
import { breakpoints } from '@vzrf/react-theme-helpers';
import { calculateRem } from '@uie/javascript-style-helpers';
import * as action from '../../../action/buildProduct';
import { updateSCTags } from '../../../service/dtmTag';
import { InHomeUtils } from '../../../util/inhomeUtils';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { Title } from '@vds/typography';

const ModalContaier = styled.div`
    // padding: ${calculateRem(0, 0, 20)};
    min-height: ${calculateRem(64)};

    @media only screen and (min-width: ${breakpoints.md}) {
        // padding:${calculateRem(0, 0, 20)};
        min-height: ${calculateRem(64)};
    };

    @media only screen and (max-width: ${breakpoints.md}) {
        margin: ${calculateRem(35, 0, 0)};
    };
`;
const HeaderContainer = styled.div`
    margin: ${calculateRem(30, 20, 10)};
`;

const ButtonRow = styled.div`
    width: 100%;
    text-align: center;
    margin-bottom: ${calculateRem(20)};

    @media only screen and (min-width: ${breakpoints.md}) {
        // margin: ${calculateRem(33, 0)};
        margin-top: 32px;
    }

    // & ${Button} {
    //     margin: 0;
    //     border-radius: 0;
    //     width: ${calculateRem(240)};
    //     border: 0;
    //     padding-top: ${calculateRem(14)};
    //     padding-bottom: ${calculateRem(14)};
    //     background: #333333;
    //     line-height: 1.25;
    //   }
`;

const UnorderedList = styled.ul`
    line-height: 1.25;
    letter-spacing: 0.25px;
    color: #333333;
    padding: ${calculateRem(0, 0, 0, 15)};
    margin: 0;
`;

const UnorderedListItem = styled.li`
      margin-bottom: ${calculateRem(24)};
`;

const ModalHeader = (title) => (
    <ModalTitle>
        {title}
    </ModalTitle>
);

class FiosFiveStartComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fiosFiveModalSate: 'intro'
        };
        this.isReskin = props.buildProduct?.isReskin && props.lqState && props.lqState.runtimeKey && props.lqState.runtimeKey.EnableReskin === 'Y';
    }

    startAction = () => {
        action.setFiosFiveModalDetails('pickChannels', [], this.props.dispatch) 
        updateSCTags("start");          
    }

    title = () => {
        let title = '';

        if(this.props.flowFor === 'new') {
            title = 'Choose your 5 favorite channels.'
        } else {
            title = 'Update your 5 channels.'
        }
        return title;
    }

    render() {
       
        /*** Vaicom Blackout text */
        let vaicomBlackout = '';
        if(this.props.disclaimerProductsFragments && this.props.disclaimerProductsFragments.comBlackout && InHomeUtils.isNotNull(this.props.disclaimerProductsFragments.comBlackout)) {
            vaicomBlackout = <UnorderedListItem>{ReactHtmlParser(this.props.disclaimerProductsFragments.comBlackout.disclaimer)}</UnorderedListItem>
        }

        let isPega = false
        isPega = InHomeUtils.isNotNull(this.props.isPega) && this.props.isPega
        
        return (
            <React.Fragment>
                <ModalContaier>
                    {ModalHeader(this.title())}                   
                    <ModalBody> 
                    {this.props.flowFor === 'new' ? 
                        
                        <div style={{margin: '0px'}} className="chooseFevChannels">
                            {this.isReskin ?  
                                <UnorderedList>
                                    <UnorderedListItem>Choose 5 of your favorite channels from almost 200 available networks.</UnorderedListItem>
                                    <UnorderedListItem>Get a recommended package based on your channel selections.</UnorderedListItem>
                                    <UnorderedListItem>In addition, get the major broadcast networks such as ABC, CBS, CW, FOX, MyNet, NBC, Telemundo and Univision.</UnorderedListItem>
                                    <UnorderedListItem>Plus, you can update your 5 favorite channels, every month and free of charge.</UnorderedListItem>
                                </UnorderedList>
                            :
                                <UnorderedList>
                                    <UnorderedListItem>Now, you can personalize your TV package by picking five of your favorite channels from
                                    almost 200 available networks.</UnorderedListItem>
                                    <UnorderedListItem>Once you choose your five favorite channels, we'll recommend a package based on those 
                                    preferences.</UnorderedListItem>
                                    <UnorderedListItem>No matter what channels you choose, you'll still get the major broadcast networks, like <b>ABC, CBS, 
                                    CW, FOX, MyNet, NBC, Telemundo and Univision</b>.</UnorderedListItem>
                                    <UnorderedListItem>Want to change your five favorite channels?
                                    You can do so - every month, free of charge.</UnorderedListItem>
                                    {vaicomBlackout}
                                </UnorderedList> 
                            }
                        </div>
                    : 
                    <UnorderedList>
                    

                        <UnorderedListItem>Over 400 Channels to choose from</UnorderedListItem>
                        {/* <UnorderedListItem><b>Channel changes will go into effect on June 1, 2019</b></UnorderedListItem> */}
                    </UnorderedList> }
                        </ModalBody> 
                </ModalContaier>
                {!isPega && <ButtonRow>
                    <div className="text-left modalFooterButtonReskin2" style={{width:"100%"}}>
                        <Button onClick={this.startAction} >Start</Button>
                    </div>
                </ButtonRow>}
            </React.Fragment>
        );
    }
}

export default FiosFiveStartComponent;


 